module.exports = __webpack_public_path__ + "img/arrow-down.21972b8a.svg";